import { useTranslation } from 'next-i18next';
import { useRef } from 'react';
import useEditorPanelButtonStore from "../../store/useEditorPanelButtonStore";
import Field from '../Field';
import Modal from '../Modal';

const ImageModal = () => {
  const { t } = useTranslation(['common', 'convert-and-edit']);
  const ref = useRef(null);

  const store = useEditorPanelButtonStore()

  const handleCreateImage = () => {
    const image = URL.createObjectURL(ref.current.files[0]);
    store.setImageList([...store.imageList, image])
    store.setIsImageModalOpen(false)
  }

  return (
    <Modal
      show={store.isImageModalOpen}
      className="image-modal"
      text={t('convert-and-edit:image-modal')}
      cancelButtonProps={{
        onClick: () => store.setIsImageModalOpen(false),
      }}
      okButtonProps={{
        onClick: handleCreateImage,
      }}
    >
      <Field size="md">
        <Field.Input
          ref={ref}
          type='file'
          id='files'
          accept="image/png, image/jpeg"
        />
      </Field>
    </Modal>
  );
};

export default ImageModal;
